// extracted by mini-css-extract-plugin
export default {"list":"ServicesCategoriesList_list__M789p"};